var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiCarChildSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 11.25C42.5 14.75 39.75 17.5 36.25 17.5C32.75 17.5 30 14.75 30 11.25C30 7.75 32.75 5 36.25 5C39.75 5 42.5 7.75 42.5 11.25ZM37.5 20H35.5C30.25 20 25.25 17 22.75 12.25C22.5 12 22.25 11.75 22.25 11.5L17.75 13.5C19 17 23 21.5 28.75 23.75L24.25 36.25L14.5 33.5L7.5 47.25L12.5 48.5L17 39.5L28.25 42.5C30.75 43 33.25 41.75 34.25 39.5L40 23.5C40.5 21.75 39.25 20 37.5 20ZM47.25 17.5L38.75 41C37.25 45 33.5 47.5 29.5 47.5C28.75 47.5 27.75 47.5 27 47.25L19.75 45.25L17.5 49.75L22.5 51L26 52C27.25 52.25 28.5 52.5 29.75 52.5C36 52.5 41.5 48.75 43.75 42.75L52.5 17.5H47.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCarChildSeat);
export default __webpack_public_path__ + "static/media/mdi_car-child-seat.ab3761d737445d485559311b1ca32d56.svg";
export { ForwardRef as ReactComponent };